import clsx from "clsx";

type Props = {
  className?: string;
  percent: number;
};

export default function LinearIndicator({ className, percent }: Props) {
  return (
    <div className={clsx("relative isolate rounded-[0.25rem] overflow-clip", className)}>
      <div
        className="absolute top-0 bottom-0 left-0 right-0 bg-white"
        style={{
          clipPath: `polygon(0% 0%, ${percent}% 0%, ${percent}% 100%, 0% 100%)`,
        }}
      />
      <div className="absolute top-0 bottom-0 left-0 right-0 bg-white/30" />
    </div>
  );
}
